import React, {useEffect, useState} from 'react';
import SearchField from '@/components/ui/search-field';
import {Box} from '@mui/material';

interface SearchBarProps {
  onSearch: (searchTerm: string) => void;
  placeholder: string;
  searchText?: string | null;
  isInFilter?: boolean;
  maxWidth?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder,
  searchText,
  isInFilter = false,
  maxWidth = false
}) => {
  const [localSearchText, setLocalSearchText] = useState('');

  const handleInputChange = (value: string) => {
    setLocalSearchText(value);
    onSearch(value);
  };

  useEffect(() => {
    if (isInFilter && !searchText) {
      setLocalSearchText('');
    }
  }, [isInFilter, searchText]);

  return (
    <Box
      margin="auto"
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: {xs: maxWidth ? '100%' : '80%', sm: maxWidth ? '100%' : '60%'}
      }}
      marginTop={1}
    >
      <SearchField
        value={searchText || localSearchText}
        onChange={handleInputChange}
        placeholder={placeholder}
      />
    </Box>
  );
};

export default SearchBar;
